import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'

const initialState = {
  sensorsData: {
    status: "idle",
    data: {},
    error: {},
  },
}

export const fetchData = createAsyncThunk('sensors', async (data) => {
  const {token} = data
  const axios = require("axios")
  const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/sensors/YILI`
       const response = await axios.get(url , 
                 { headers })
      return response.data
})

const sensorsSlice = createSlice({
  name: 'sensors',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchData.pending.type]:(state, action) => {
      state.sensorsData = {
        status: "loading",
        data: {},
        error: {},
      }
    },
    [fetchData.fulfilled.type]:(state, action) => {
      state.sensorsData = {
        status: "idle",
        data: action.payload,
        error: {},
      }
    },
    [fetchData.rejected.type]:(state, action) => {
      state.sensorsData = {
        status: "idle",
        data: {},
        error: "unauthorized",
      }
    },
  }
})

export default sensorsSlice.reducer
